import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/icon/style";
import _Icon from "antd/lib/icon";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits"; /*@客户-客户端下载*/
import React from 'react';
import './index.scss';
import { withRouter } from 'react-router-dom';
import { injectIntl } from "react-intl";
import { domain } from '../../../utils/commonConsts';
import windows from "../../../assets/img/windows2.png";
import mac from "../../../assets/img/mac.png";
import android from "../../../assets/img/android.png";
import ios from "../../../assets/img/ios.png";
var CI0001 = /*#__PURE__*/function (_React$Component) {
  _inherits(CI0001, _React$Component);
  function CI0001(props) {
    var _this;
    _classCallCheck(this, CI0001);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CI0001).call(this, props));
    _this.state = {};
    return _this;
  }
  _createClass(CI0001, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_Card, {
        className: "card"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ci0001NameBox"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "ci0001Name"
      }, "UAnywhere client"), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: '16px'
        }
      }, "Download now and experience stable, high-speed, secure, and reliable SD-WAN services anytime, anywhere")), /*#__PURE__*/React.createElement("ul", {
        className: "downloadbox"
      }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
        className: "downloadpic"
      }, /*#__PURE__*/React.createElement("img", {
        src: windows,
        alt: ""
      })), /*#__PURE__*/React.createElement(_Button, {
        className: "ci0001button",
        href: domain + "/dl/APP/WINDOWS/unet.zip"
      }, "Windows")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
        className: "downloadpic"
      }, /*#__PURE__*/React.createElement("img", {
        src: mac,
        alt: ""
      })), /*#__PURE__*/React.createElement(_Button, {
        target: "_blank",
        className: "ci0001button",
        href: "https://apps.apple.com/cn/app/uanywhere/id1549864431?mt=12"
      }, "MAC")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
        className: "downloadpic"
      }, /*#__PURE__*/React.createElement("img", {
        src: android,
        alt: ""
      })), /*#__PURE__*/React.createElement("div", {
        className: "ci0001button bordernone"
      }, /*#__PURE__*/React.createElement(_Icon, {
        type: "apple",
        theme: "filled",
        style: {
          marginRight: 5
        }
      }), "App Store Download")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
        className: "downloadpic"
      }, /*#__PURE__*/React.createElement("img", {
        src: ios,
        alt: ""
      })), /*#__PURE__*/React.createElement("div", {
        className: "ci0001button bordernone"
      }, /*#__PURE__*/React.createElement(_Icon, {
        type: "android",
        theme: "filled",
        style: {
          marginRight: 5
        }
      }), "Android version download"))));
    }
  }]);
  return CI0001;
}(React.Component);
export default withRouter(injectIntl(CI0001));